import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { Ref, ref } from "vue";
import SpecialCaseModals from "@/components/DailyReportUpdateModalParts/SpecialCaseModals.vue";
import DeliveryPlan from "@/types/DeliveryPlan";
import { DELIVERY_PLAN_RULE_2024_START_DATE_TIME } from "@/services/consts";


export default /*@__PURE__*/_defineComponent({
  __name: 'SpecialCaseButton',
  props: {
    deliveryPlan: {},
    createAuthority: { type: Boolean },
    showFlash: { type: Function }
  },
  setup(__props: any) {

const props = __props

const modalStatus: Ref<boolean> = ref(false)

function changeModalStatus(bool: boolean) {
  modalStatus.value = bool;
}

function showButton() {
  return props.deliveryPlan.leaving_warehouse_date_time >= DELIVERY_PLAN_RULE_2024_START_DATE_TIME
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showButton())
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 0,
          color: "grey-lighten-4",
          style: {"color":"red !important"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (changeModalStatus(true)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('pages.dailyReports.updateModal.applicationOfSpecialCaseButton')), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(SpecialCaseModals, {
      modelValue: modalStatus.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modalStatus).value = $event)),
      deliveryPlan: props.deliveryPlan,
      createAuthority: props.createAuthority,
      showFlash: props.showFlash,
      onCancel: changeModalStatus
    }, null, 8, ["modelValue", "deliveryPlan", "createAuthority", "showFlash"])
  ], 64))
}
}

})